export default __webpack_public_path__ + "static/media/unity-mwu-white.5a944b17.png";